import React, {Component} from "react";
import TabViewPresvalView from "./TabViewPresvalView";

export default class TabViewPresvalContainer extends Component {
    constructor(props) {
        super(props);
        this.setTabs = this.setTabs.bind(this);
        this.manageIndex = this.manageIndex.bind(this);

        this.state = {
            modelOptions: props.modelOptions ? props.modelOptions : [],
            activeIndex: props.activeIndex ? props.activeIndex : 0,
            tabWidth: props.modelOptions ? (100 / props.modelOptions.length).toString() + '%': '0%',
        };
        this.setTabs();
    }

    setTabs(){
        let modelOptionsAux = this.state.modelOptions;
        modelOptionsAux.forEach((elem, index)=>{
            elem['index'] = index;
        });
        this.setState({
            modelOptions: modelOptionsAux,
        })
    }
    manageIndex(elem){
        this.props.onSelect(elem);
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.activeIndex !== this.props.activeIndex){
            this.setState({
                activeIndex: this.props.activeIndex,
            })
        }
    }

    render() {
        const {modelOptions, tabWidth, activeIndex} = this.state;

        return <TabViewPresvalView
            modelOptions={modelOptions}
            tabWidth={tabWidth}
            activeIndex={activeIndex}
            manageIndex={this.manageIndex}
        />
    }
}